import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'babel-polyfill'
import 'default-passive-events'
import './plugins/element.js'


// 样式
import './styles/commonX.less'
import { ElMessage } from './js/message.js'
Vue.prototype.$message = new ElMessage()

Vue.config.productionTip = false

// 引入axios
import instance from './api/index.js';
import apiPath from './api/path.js';
Vue.prototype.$http = instance;
Vue.prototype.$apiPath = apiPath;

// 引入全局方法
import commonJs from './js/commonJs'
Vue.prototype.$commonJs = commonJs
import parameterConfig from './js/parameterConfig' // 全局变量
Vue.prototype.$parameterConfig = parameterConfig
import commonEcharts from './js/commonEcharts.js'
Vue.prototype.$commonEcharts = commonEcharts
import DES from "./js/des.js";
Vue.prototype.$des = DES



// 引入全局过滤器
import * as filters from './js/filters.js'
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
});

//全局自定义组件
import Development from './components/lv-common/develop.vue' //开发中
Vue.component("Development", Development);
import Reback from './components/lv-common/reback.vue' //返回
Vue.component("Reback", Reback);
import BankCardList from './components/lv-common/bankCardList.vue' //银行卡
Vue.component("BankCardList", BankCardList);
import ReduceCoupon from './components/lv-common/reduceCoupon.vue' //立减券
Vue.component("ReduceCoupon", ReduceCoupon);
import FullReduceCoupon from './components/lv-common/fullReductionCoupon.vue' //满减券
Vue.component("FullReduceCoupon", FullReduceCoupon);
import RiskTips from './components/lv-common/riskTips.vue' //风险
Vue.component("RiskTips", RiskTips);
import Perfect from './components/lv-common/perfect.vue' //完善信息提示
Vue.component("Perfect", Perfect);

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')